
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';

export const userAccountConfig = {
    personal:  {
        title: 'personal',
        icon: <UpdateOutlinedIcon />,
    },
    security: {
        title: 'security',
        icon: <LockOutlinedIcon />,
    },
    myReports: {
        title: 'feedback_my_reports_title',
        icon: <FeedbackOutlinedIcon />,
    },
};
